import { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { useAlertContext } from './AlertProvider'
import styles from './Alert.module.scss'

type Props = HTMLAttributes<HTMLDivElement>

export const AlertTitle = ({ className, ...props }: Props) => {
  const { status } = useAlertContext()

  return <div {...props} data-status={status} className={classNames(styles.title, className)} />
}
